<template>
  <template v-if="shouldDisplayNavigation">
    <navigation />
  </template>

  <main
    :class="[
      'wrapper',
      'wrapper-padding-top',
      shouldDisplayNavigation ? '' : 'wrapper-padding-top-0'
    ]">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component
          :is="Component" />
      </keep-alive>
    </router-view>

    <aside class="qrcode-wrapper">
      <div class="qrcode">
        <img
          src="https://static.nuonuo.com.cn/zycmp/ichenuonuo-qrcode.png"
          alt="微信扫描二维码，关注爱车的诺诺">
      </div>
    </aside>
  </main>
</template>

<script>
// import {useRoute} from 'vue-router'
import Navigation from '@components/navigation'

export default {
  name: 'App',

  components: {
    Navigation,
  },

  computed: {
    // shouldDisplayNavigation
    // - 2022.11.14
    // - When to hide navigation
    //   - When inside Wechat mini program
    //   - when inside Douyin microapp
    // - 2024.04.03
    // - Add condition: when current page is part of
    //   'report inspection' module
    shouldDisplayNavigation () {
      // Check if not inside Wechat mini program
      // or Douyin microapp
      const ua = window.navigator.userAgent.toLowerCase()
      const notWechat = !/miniProgram/ig.test(ua)
      const notWework = !/toutiaomicroapp/ig.test(ua)

      // Check if not in IBS project URL
      var url = (window.location != window.parent.location)
        ? document.referrer
        : document.location.href
      const notIbs = url !== 'http://ibs.nuo.com/'
        && url !== 'https://test-ibs.ichenuonuo.com/'
        && url !== 'https://ibs.nuonuo.com.cn/'

      // Check if current page is not "pictures"
      const route = this.$route
      const notPictures = route && route.name !== 'pictures'

      // Check if current page is not part of
      // "report inspection" module
      const notReportInspection = route
        && route.name !== 'CarReportInspectionIndex'
        && route.name !== 'CarReportInspectionChecklist'
        && route.name !== 'CarReportInspectionChecklistTable'
        && route.name !== 'CarReportInspectionChecklistDetail'
        && route.name !== 'CarReportInspectionMaintenanceRecord'
        && route.name !== 'CarReportInspectionMileageAnalysisBasis'
        && route.name !== 'CarReportInspectionAccidentRecord'
        && route.name !== 'CarReportInspectionNotice'

      // notReportInspectionPreview
      // - 2025.05.16
      // - Check if current page is not part of "report inspection preview"
      const notReportInspectionPreview = route
        && route.name !== 'CarReportInspectionPreview'

      return notWechat
        && notWework
        && notPictures
        && notReportInspection
        && notReportInspectionPreview
        && notIbs
        && notReportInspectionPreview
    },
  },
}
</script>

<style lang="scss">
@use './sass/index.scss' as *;
@use './sass/common.scss' as *;
@use './sass/common.desktop.scss' as *;

// wrapper padding-top
// which value should be exactly as the height of navigation
.wrapper-padding-top {
  padding-top: 44px;
}

@media (min-width: 760px) {
  .wrapper-padding-top {
    padding-top: 56px;
  }
}

// wrapper padding top 0
// when padding top
.wrapper-padding-top-0 {
  padding-top: 0!important;
}
</style>
